import type { ReorderReport } from './contracts';

/**
 * Turns a reorder report into one sentence for a toast. Read the way an operator would: "how much
 * of my old order actually made it into the cart, and what needs my attention." A report that
 * carried everything unchanged says so plainly rather than listing zero adjustments and zero
 * skips, which would read as "something is wrong" rather than "nothing was wrong".
 */
export function describeReorderReport(report: ReorderReport): string {
  const parts: string[] = [];
  // `adjusted` and `skipped` are optional on the generated contract — absent, not just empty,
  // when reordering did not need to touch or drop anything.
  const adjusted = report.adjusted ?? [];
  const skipped = report.skipped ?? [];

  if (report.carried > 0) {
    parts.push(
      `${String(report.carried)} ${report.carried === 1 ? 'item adicionado' : 'itens adicionados'}`,
    );
  }
  if (adjusted.length > 0) {
    parts.push(
      `${String(adjusted.length)} ${adjusted.length === 1 ? 'item ajustado' : 'itens ajustados'}`,
    );
  }
  if (skipped.length > 0) {
    parts.push(
      `${String(skipped.length)} ${
        skipped.length === 1 ? 'item não pôde ser adicionado' : 'itens não puderam ser adicionados'
      }`,
    );
  }

  return parts.length === 0
    ? 'Nenhum item do pedido original pôde ser adicionado.'
    : parts.join(' · ');
}
